import React, { Component } from 'react';

class Feature2 extends Component {
    constructor(props){
        super(props);
        this.state = {
           feature: [
                {
                    id: 1,
                    icon: 'bi bi-badge2',
                    title: 'Emprededores',
                    text: 'Pensado para quienes buscan la innovación, creación y desarrollo de nuevas ideas de negocio.'
                },
                {
                    id: 2,
                    icon: 'bi bi-article',
                    title: 'Profesores',
                    text: 'Una herramienta útil para enriquecer sus clases y ofrecer nuevos enfoques a sus estudiantes.'
                },
                {
                    id: 3,
                    icon: 'bi bi-headset',
                    title: 'Estudiantes',
                    text: 'Un recurso práctico para ampliar conocimientos y reforzar su aprendizaje académico.'
                }
            ]
        }
    }

    render() {
        return (
            <section className="feature-2 pt-100 dark-bg-light">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="section-heading center-heading text-center mb-60">
                                <h3 className="heading-title">¿A quien va dirigido el libro?</h3>
                                <p>Este libro ofrece una valiosa oportunidad a profesionales de diversas áreas que desean seguir creciendo y expandiendo sus conocimientos.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        {
                            this.state.feature.map((data,i) => (
                                <div className="col-lg-4 col-md-6">
                                    <div className="feature-style-2 mb-4 mb-lg-0" key={i}>
                                        <i className={data.icon}></i>
                                        <div className="feature-text">
                                            <h4>{data.title}</h4>
                                            <p>{data.text}</p>
                                        </div>
                                    </div>
                                </div>
                            
                            ))
                        }
                        
                    </div>
                </div>
            </section> 
        );
    }
}

export default Feature2;
